var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCreditDebitCard = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "credit_debit._card",
    "data-name": "credit/debit. card",
    transform: "translate(12002 -19404)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_647",
    "data-name": "Rectangle 647",
    width: 24,
    height: 24,
    transform: "translate(-12002 19404)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "credit_debit._card-2",
    "data-name": "credit/debit. card",
    transform: "translate(-12000 19329)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4972",
    "data-name": "Path 4972",
    d: "M17.812,80H2.187A2.19,2.19,0,0,0,0,82.188v9.375A2.19,2.19,0,0,0,2.187,93.75H17.812A2.19,2.19,0,0,0,20,91.563V82.188A2.19,2.19,0,0,0,17.812,80ZM2.187,81.25H17.812a.939.939,0,0,1,.938.938v1.25H1.25v-1.25A.939.939,0,0,1,2.187,81.25ZM17.812,92.5H2.187a.939.939,0,0,1-.937-.937V84.688h17.5v6.875A.939.939,0,0,1,17.812,92.5Z",
    transform: "translate(0 0)",
    fill: "#2884ff",
    stroke: "#2884ff",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4973",
    "data-name": "Path 4973",
    d: "M81.207,305.81h-.6a.6.6,0,0,1-.6-.6v-.6a.6.6,0,0,1,.6-.6h.6a.6.6,0,0,1,.6.6v.6A.6.6,0,0,1,81.207,305.81Z",
    transform: "translate(-76.864 -215.202)",
    fill: "#2884ff",
    stroke: "#2884ff",
    strokeWidth: 0.4
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCreditDebitCard);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/credit_debit_card.872fded5fd119bc0f24967664632e41f.svg";